import { render, staticRenderFns } from "./PricingBox.vue?vue&type=template&id=2852dcb5&scoped=true&"
import script from "./PricingBox.vue?vue&type=script&lang=js&"
export * from "./PricingBox.vue?vue&type=script&lang=js&"
import style0 from "./PricingBox.vue?vue&type=style&index=0&id=2852dcb5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2852dcb5",
  null
  
)

export default component.exports